/* @flow */
/* eslint-env es6,browser */

import { isObject, isFunction } from './utils/coreutils';
// eslint-disable-next-line import/extensions
import { version as _apiVersion, name as _apiName } from '../../package';

/**
 * @description module for utility functions
 * @module utils
 */

interface WindowCrypto {
  getRandomValues(Uint8Array): Uint8Array;
}

/**
 * returns JSAPI library name
 *
 * @exports apiName
 * @returns {string} - JSAPI Name
 */
export function apiName(): string {
  return _apiName;
}

/**
 *
 * JSAPI library version
 *
 * @exports apiVersion
 * @returns {string} - JSAPI Versions string
 */
export function apiVersion(): string {
  return _apiVersion;
}

/**
 * random string generator
 *
 * @returns {string} - Random number
 */
export function getRandom(): string {
  return Math.random().toString().slice(2, 11);
}

/**
 * Returns random data using the Crypto API if available and Math.random if not
 * Method is from https://gist.github.com/jed/982883 like generateUUID, direct link https://gist.github.com/jed/982883#gistcomment-45104
 *
 * @returns {number} - unique number
 * @access private
 */
function _getRandomData(): number {
  // eslint-disable-next-line compat/compat
  const objCrypto: WindowCrypto = window.crypto;
  // $FlowFixMe
  if (isObject(objCrypto) && isFunction(objCrypto.getRandomValues)) {
    // eslint-disable-next-line compat/compat
    return objCrypto.getRandomValues(new Uint8Array(1))[0] % 16;
  }
  return Math.random() * 16;
}

/**
 * Returns a random v4 UUID of the form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx,
 * where each x is replaced with a random hexadecimal digit from 0 to f,
 * and y is replaced with a random hexadecimal digit from 8 to b.
 * https://gist.github.com/jed/982883 via node-uuid
 *
 * @param {string} match - placeholder
 * @returns {string} - unique user id
 */
export function generateUUID(match?: string = ''): string {
  if (match.length === 1) {
    const nMatch = Number(match);
    // eslint-disable-next-line no-bitwise
    return (nMatch ^ (_getRandomData() >> (nMatch / 4))).toString(16);
  }
  return `${1e7}-${1e3}-${4e3}-${8e3}-${1e11}`.replace(/[018]/g, generateUUID);
}
/**
 *Get top level domain (netzero.net or juno.com)
 *
 * @param {window} w - window object
 * @returns {string} - Top level domain
 */
export function getTopLevelDomain(w?: WindowProxy = window): string {
  // Split domain by '.' , get last two elements in the array and join them
  const loc: Location = w.location;
  return loc.host.split('.').slice(-2).join('.');
}
